import React, { useContext } from "react";

export const GymflowModelsContext = React.createContext<{ 
  /*** Too keep backwards compatibility this will be typed as any even though we know it to be of ApiType,
   * Feel free to cast it as needed. We'll change the type once all the hooks & api's are migrated to typescript
  */
  api: any 
}>(
  {} as any,
);
const useGymflowModels = () => {
  return useContext(GymflowModelsContext);
};

export default useGymflowModels;
